module.exports = __webpack_public_path__ + "static/img/Vector.7c6c7b23.svg";